import React, {useState, useEffect} from 'react';
// import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
// import {Link} from 'react-router-dom';
import {Spinner} from '../Spinner/Spinner';
import {runQuery} from '../utils'
import {getResources} from './queries'

interface MyComponentProps {
  resourceTypeId: string
  handleChangeInfo?: any,
}

export const ResourceTypeList: React.FC<MyComponentProps> = (props) => {
  const [resources, setResources] = useState<any[]>([])
  const [loadStatus, setLoadStatus] = useState<string>("idle")
  const [filter, setFilter] = useState("")

  useEffect(() => {
    const results = runQuery(getResources(props.resourceTypeId))
    setLoadStatus("fetching")
    results.then((d) => {
      setLoadStatus("idle")
      setResources(d.data.results.bindings)
    })
  }, [props.resourceTypeId])
  return (
    <div>
      <h1>{props.resourceTypeId}</h1>
      <Form.Control as="input" type="text" placeholder="filter" onChange={(e) => setFilter(e.target.value)} value={filter}/>
      {loadStatus === "fetching" ? <Spinner/> :
      resources.map((r) => {
        //check against error resources with ids
        if (r.resource.value !== "http://scta.info/resource/"){
          if (r.resourceTitle.value.toLowerCase().includes(filter.toLowerCase())){
            return <p key={r.resource.value}><span className="lbp-span-link" onClick={() => props.handleChangeInfo(r.resource.value)}>{r.resourceTitle.value}</span></p>
          }
          else{
            return null
          }
        }
        else{ 
          return null
        }
      })
    }
    </div>

  )
}

